import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";

import { greyDarkWithOpacity } from "@/angelouCE/utils/constants";

const { colors } = constants;

const blue = colors.ui.core[700];
const grey = colors.ui.neutral[500];
const greyDark = colors.ui.neutral[600];
const greyLight = colors.ui.neutral[100];
const greyExtraLight = colors.ui.neutral[25];

export const rootCss = {
  listStyleType: "none",
  margin: "8px 0",
};

export const buttonCss = (
  useInactiveStyles: boolean,
  isExternalResource: boolean,
): CSSObject => ({
  alignItems: "center",
  backgroundColor: greyExtraLight,
  borderRadius: "4px",
  color: isExternalResource ? blue : greyDark,
  display: "flex",
  padding: "8px 8px 8px 16px",
  width: "100%",
  font: "inherit",
  gap: 0,
  justifyContent: "space-between",
  border: `1px solid ${isExternalResource ? greyLight : "transparent"}`,

  "&": {
    opacity: 1,
  },

  "&:hover": {
    backgroundColor: useInactiveStyles ? greyExtraLight : greyDarkWithOpacity,
  },

  "&[disabled], :hover[disabled]": {
    backgroundColor: greyExtraLight,
    opacity: 1,
  },
});

export const iconCss = (isExternalResource: boolean): CSSObject => ({
  height: "32px",
  justifyContent: "center",
  alignSelf: "center",
  width: "32px",
  padding: "8px 11px",
  marginRight: isExternalResource ? "5px" : "0",

  svg: {
    width: "20px",
    height: "20px",

    path: {
      stroke: grey,
    },
  },
});
